import { Component, Input, OnInit } from '@angular/core';
import { ISystemEvent } from 'src/app/shared/interfaces/system-event.interface';
import { SystemEventService } from '../../../services/system-event.service';
import { SystemEventParentType } from 'src/app/shared/enums/system-event-parent-type';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-update-system-events-list-button',
    templateUrl: './update-system-events-list-button.component.html',
    styleUrls: ['./update-system-events-list-button.component.scss']
})
export class UpdateSystemEventsListButtonComponent implements OnInit {
    @Input()
    stateEnv: string;

    @Input()
    parentId: any;

    @Input()
    parentType: SystemEventParentType;

    @Input()
    updateDataHandler: (data: ISystemEvent<any>[]) => void;

    constructor(private readonly systemEventService: SystemEventService) {}

    ngOnInit(): void {}

    updateSystemEvents() {
        if (!this.stateEnv || !this.parentId || !this.parentType) {
            return of();
        }
        return this.systemEventService
            .getSystemEvents(this.stateEnv.toLocaleLowerCase(), this.parentId, this.parentType)
            .pipe(
                map((data: ISystemEvent<any>[]) => {
                    this.updateDataHandler(data);
                })
            );
    }
}
